export default __webpack_public_path__ + "static/media/pricing-building.jpeg?.0cb98aa1";